<template>
  <div>
    <!-- <euros-header :titre="`Résultats`" btnRetour="Liste" pathRetour="/patients"></euros-header> -->
    <div class="position-relative w-100">
      <div class="position-fixed" style="z-index: 2000; top: 10px; right: 10px">
        <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon" @click="finish"
          style="width: 30px; height: 30px; min-height: 0">
          <icon width="20" height="20" name="times"></icon>
        </div>
      </div>
      <div class="position-fixed d-flex justify-content-center align-items-center" v-if="zoomedFile && showZoom"
        @click="showZoom = false"
        style="z-index: 10000; top: 0; left: 0; width: 100vw; height: 100vh; background-color: rgba(0, 0, 0, 0.8)">
        <div class="zoomed-image">
          <img :src="$config.server_url +
            '/api/1.0/files/patient/' +
            $route.params.id +
            '/' +
            zoomedFile.fi_id +
            '?token=' +
            $store.state.accesstoken +
            '&origin=webapp'
            " alt="Zoomed Image" class="img-fluid" />
          <div class="close-zoom" @click="showZoom = false">
            <icon width="24" height="24" name="times" class="" color="black"></icon>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-blue">
      <div class="row">
        <div class="col pt-5 pb-4">
          <h1>ACTIVITÉS</h1>
          <h2>GENOU</h2>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12">
          <div class="float-right mt-2">
            <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
              style="width: 30px; height: 30px" @click="editProthesis(3)">
              <icon class="" name="pen"></icon>
            </div>
          </div>
          <h3 class="mb-0">Patient</h3>
          <h2 class="mb-1">{{ patient.pa_name }} <span class="date"></span></h2>
          <div>
            <span v-if="patient.pa_sex > 0">
              <span v-if="patient.pa_sex == 1">Homme | </span>
              <span v-if="patient.pa_sex == 2">Femme | </span>
            </span>
            <span v-if="age > 0">
              {{ age }}&nbsp;ans |
              <!-- <span style="font-size: 0.7rem">(Né(e) le {{$dayjs(patient.pa_birthdate).format("DD/MM/YYYY") }})</span> -->
            </span>
            <span v-if="patient.pa_weight">{{ patient.pa_weight }}&nbsp;Kg | </span>
            <span v-if="patient.pa_height">{{ patient.pa_height }}&nbsp;cm | </span>
            <span v-if="patient.pa_lateralite">
              <span v-if="patient.pa_lateralite == 'right'">Côté droit</span>
              <span v-if="patient.pa_lateralite !== 'right'">Côté gauche</span>
            </span>
            <br />
            <span v-if="patient.pa_dateoperation">
              <span class="date">Date opératoire G0 : {{ $dayjs(patient.pa_dateoperation).format("DD/MM/YYYY") }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <table class="table">
            <thead>
              <tr>
                <th>Tibia</th>
                <th class="text-center">ML</th>
                <th class="text-center">AP</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Tibia estimé</td>
                <td class="text-center">{{ patient.pa_probaTibiaML }}</td>
                <td class="text-center">{{ patient.pa_probaTibiaAP }}</td>
              </tr>
              <tr>
                <td>Taille recommandée</td>
                <td class="text-center">{{ patient.pa_probaTailleTibiaML }}</td>
                <td class="text-center">{{ patient.pa_probaTailleTibiaAP }}</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th>Fémur</th>
                <th class="text-center">ML</th>
                <th class="text-center">AP</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Fémur estimé</td>
                <td class="text-center">{{ patient.pa_probaFemurML }}</td>
                <td class="text-center">{{ patient.pa_probaFemurAP }}</td>
              </tr>
              <tr>
                <td>Taille recommandée</td>
                <td class="text-center">{{ patient.pa_probaTailleFemurML }}</td>
                <td class="text-center">{{ patient.pa_probaTailleFemurAP }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-3" v-if="showSavedPatientSections">
        <div class="col">
          <h6 class="mb-0">REMARQUES</h6>
          <div v-if="!editComment">
            <div class="float-right">
              <div class="rounded-circle d-flex align-items-center justify-content-center btn-icon"
                style="width: 30px; height: 30px" @click="editComment = true">
                <icon class="" name="pen"></icon>
              </div>
            </div>
            <div class="mb-1" v-html="nl2br(patient.pa_comment)"></div>
          </div>
          <div v-else class="text-right">
            <textarea name="pa_comment" style="width: 100%" id="" cols="30" rows="5"
              v-model="patient.pa_comment"></textarea>
          </div>
        </div>
      </div>
      <div class="row" v-if="showSavedPatientSections">
        <div class="col">
          <hr style="height: 3px; border-top: 4px dotted #333;" />
          <h3 class="mb-0">Post opératoire</h3>
          <div class="row">
            <div class="col">
              <div v-for="(file, index) in patient.files" :key="index" class="px-2 py-2 border-bottom"
                @click="zoom(file)">
                <img ref="imgRadio" class="" :src="$config.server_url +
                  '/api/1.0/files/patient/' +
                  $route.params.id +
                  '/' +
                  file.fi_id +
                  '?token=' +
                  $store.state.accesstoken +
                  '&origin=webapp'
                  " alt="test" @load="imageLoaded" style="max-width: 150px; max-height: 150px; object-fit: contain" />
              </div>
            </div>
            <div class="col">
              <div class="d-flex align-items-center justify-content-center justify-content-md-end pt-3">
                <div class="mr-5">
                  <!-- <div @click="changefile" class="container-icon d-flex align-items-center justify-content-center"> -->
                  <strong>Radios</strong><br>peut être au format : .DICOM, .JPEG / .JPG, .PNG
                  <button class="btn btn-primary" @click="changefile">
                    <icon color="white" name="file-image" class="mr-2"></icon>+ fichier
                    <input hidden type="file" ref="inputfile" name="inputfile" accept="image/*, application/dicom" multiple
                      @change="inputFileChange($event)" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="d-flex align-items-center justify-content-center justify-content-md-end pt-3">
          <div class="mr-5">
            <div @click="changefile" class="container-icon d-flex align-items-center justify-content-center">
              <icon width="60" height="60" color="gray" name="file-image" class="mr-2"></icon>
              <input hidden type="file" ref="inputfile" name="inputfile" accept="image/*, application/dicom"
                @change="inputFileChange($event)" />
            </div>
            <div class="bis text-center mt-3">+ fichier</div>
          </div>
        </div> -->
        </div>
      </div>
      <div class="row mt-4" style="padding-bottom:100px;">
        <div class="col text-right">
          <button class="btn btn-primary" @click="validateAndClose">Valider</button>
        </div>
      </div>
    </div>

    <div class="winmodal" v-if="$store.state.help.result"></div>
    <div class="helpwin" v-if="$store.state.help.result">
      <div class="winclose">
        <label for="notdisplayanymore" style="margin: -5px 30px"><input type="checkbox" id="notdisplayanymore"
            v-model="notdisplayanymore" />Ne plus afficher</label>
        <a href="javascript:void(0);" @click="$store.commit('set_help', ['result', notdisplayanymore])">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-8">
          <h3>Explication des « delta longueur et offset ».</h3>
          <p>
            Les « delta longueur et offset » représentent les distances suivant l’axe de la tige et sa perpendiculaire
            entre le centre tête défini par
            le positionnement de la tige et celui défini par l’implant acétabulaire (distance cranio caudale pour la
            longueur et distance latérale
            pour l’offset).
          </p>
          <div>
            <button class="btn btn-primary" @click="clickHelp">SUIVANT</button>
          </div>
        </div>
        <div class="col-md-4">
          <img src="/images/aide/schemadelta.jpeg" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "result",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      pa_id: this.$route.params.id,
      patient: {},
      savePreferences: false,
      age: 0,

      tx: 0,
      ty: 0,
      scale: 1,
      numImage: "1r",
      imgRealLoaded: false,
      nbOfMmOf100pxOfCotyle: 20,

      editComment: true,
      items_cotyle_model: [],
      items_tige_model: [],
      productsTree: [],
      inputfile: null,
      zoomedFile: null,
      showZoom: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    // await this.loadTree();
    this.loadPatient();
  },
  watch: {},
  computed: {
    showSavedPatientSections() {
      return !!this.patient.pa_id;
    }
  },
  methods: {
    zoom(file) {
      this.zoomedFile = file;
      this.showZoom = true;
      // this.clickHelp();
    },
    imageLoaded() {
      // this.imgRealLoaded = true;
      // console.log("image loaded");
    },
    changefile() {
      this.$refs.inputfile.click();
    },
    async inputFileChange(e) {
      // let maxWait = 3000,
      //   time = new Date();
      if (!e.target.files.length) return;

      this.spinner = true;
      let uploadedFiles = this.patient.files || [];
      let usedSlots = new Set(uploadedFiles.map(file => file.fi_where));
      let availableSlots = ["postoperatoire", "postoperatoire2"]
        .filter(slot => !usedSlots.has(slot))
        .slice(0, Math.max(0, 2 - uploadedFiles.length));
      let files = Array.from(e.target.files).slice(0, availableSlots.length);
      if (!files.length) {
        alert("Deux fichiers post-opératoires maximum peuvent être importés.");
        e.target.value = "";
        this.spinner = false;
        return;
      }
      if (e.target.files.length > availableSlots.length) {
        alert("Deux fichiers post-opératoires maximum peuvent être importés. Seuls les emplacements disponibles seront utilisés.");
      }

      try {
        this.cancelTokenSource = this.$axios.CancelToken.source();
        for (let iFile = 0; iFile < files.length; iFile++) {
          let formdata = new FormData();
          formdata.append("file", files[iFile]);
          formdata.append("pa_id", this.patient.pa_id);
          formdata.append("fi_where", availableSlots[iFile]);
          await this.$axios.post(this.$config.server_url + "/api/1.0/files2", formdata, {
            cancelToken: this.cancelTokenSource.token,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });// import de 2 fichiers maximum
        }
        // let towait = maxWait - (new Date() - time);
        // // console.log("towait", towait);
        // if (towait > 0) {
        //   await new Promise(accept => {
        //     window.setTimeout(() => {
        //       accept();
        //     }, towait);
        //   });
        // }
        // console.log("time-new Date()", new Date() - time);
        // if (response.data.data.ext == ".dcm") this.$router.push("/prosthesis/" + response.data.data.patientId + "/1").catch(err => {});
        // else this.$router.push("/ratio/" + response.data.data.patientId).catch(err => {});
        await this.loadPatient();
        e.target.value = "";
      } catch (error) {
        alert("Le format de l'image n'est pas pris en charge.");
        this.spinner = false;
      }
    },
    // async loadTree() {
    //   // route qui récupère tous les produits triés par models, subtype, col et size  sous forme d'arbre
    //   let response = await this.$axios.get(this.$config.server_url + "/api/1.0/products/tree", {
    //     params: {}
    //   });
    //   this.productsTree = response.data.data;
    //   this.items_cotyle_model = this.productsTree[0].items;
    //   this.items_tige_model = this.productsTree[1].items;
    //   // console.log("this.productsTree", this.productsTree);
    // },
    clickHelp() {
      this.$store.commit("set_help", ["result", this.notdisplayanymore]);
    },
    async loadPatient() {
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients/" + this.pa_id);
      this.patient = response.data.data;
      // console.log("this.patient", this.patient);
      if (this.patient.pa_birthdate != "0000-00-00") this.age = dayjs().diff(dayjs(this.patient.pa_birthdate), "year");
      else this.age = 0;
      if (this.patient.pa_lateralite == "right") {
        this.numImage = "1r";
      } else {
        this.numImage = "1l";
      }
      if (this.patient.pa_cotyle) {
        this.patient.pa_cotyle.pr_name = this.patient.pa_cotyle.pr_name.replace(/ \-/g, "<br>");
      }
      if (this.patient.pa_tige) {
        this.patient.pa_tige.pr_name = this.patient.pa_tige.pr_name.replace(/ \-/g, "<br>");
      }
      if (this.patient.pa_comment) {
        this.editComment = false;
      } else {
        this.editComment = true;
      }
      // console.log("patient.createdAt", this.patient);
    },
    newPatient() {
      this.$router.push("/chooseimage").catch(err => {});
    },
    editProthesis(num) {
      this.$router.push("/editgenou/" + this.pa_id).catch(err => {});
    },
    async saveComment() {
      await this.$axios.put(this.$config.server_url + "/api/1.0/patients/" + this.patient.pa_id, {
        pa_comment: this.patient.pa_comment
      });
      this.editComment = false;
    },
    nl2br(str) {
      if (typeof str === "undefined" || str === null) {
        return "";
      }
      return (str + "").replace(/(\r\n|\n\r|\r|\n)/g, "<br>");
    },
    async validateAndClose() {
      if (this.showSavedPatientSections) {
        await this.saveComment();
      }
      this.finish();
    },
    async finish() {
      this.$router.push("/genou").catch(err => {});
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.bt {
  border-top: 1px solid #cacaca;
}

.line-product {
  padding: 20px 0;
  // border-bottom: 1px solid #cacaca;
}

.img-product {
  width: 100px;
  height: 100px;
  min-width: 100px;
  min-height: 100px;
  object-fit: contain;
  object-position: center;
}

.date {
  font-weight: 400;
}

.questionnaire-line {
  padding-bottom: 25px;
}

.bgimage,
.cotyleimage,
.tigeimage {
  position: absolute;
}

.cotyleimage {
  // position: relative;
  // pour mettre la couleur verte
  filter: invert(1) grayscale(100%) brightness(40%) sepia(100%) hue-rotate(50deg) saturate(1000%) contrast(0.8);
  width: 300px;
  height: 300px;
  overflow: hidden;
}

.tigeimage {
  // position: relative;
  // pour mettre la couleur rouge
  filter: invert(1) grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg) saturate(600%) contrast(0.8);
  width: 400px;
  height: 1000px;
  overflow: hidden;
}

.cotyleimagecontent {
  position: absolute;
  top: 0px;
  left: 0px;
}

.tigeimagecontent {
  // transform-origin: 1px 1px;
  position: absolute;
  top: 0;
  left: 0;
}

.gestoparent {
  overflow: hidden;
  border-radius: 15px;
}

.btn-icon {
  background-color: #c6091f;
  color: white;

  &.disabled {
    background-color: #a7a7a7;
  }
}
</style>
